import { createContext } from 'react';

const liveAlert = createContext();

export default liveAlert
